export default __webpack_public_path__ + "static/media/tete58.19580e23.png";